import theme from 'container/theme';

const styles = {
  tooltipTitle: {
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '20.3px',
    color: theme.colors.red,
  },
  tooltipContent: {
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20.3px',
    color: '#667185',
    padding: '0px',
    marginTop: '4px',
  },
  buttonNext: {
    color: theme.colors.red,
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontWeight: '600',
    outline: 'none',
  },
  buttonBack: {
    color: '#667185',
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontWeight: '600',
  },
  buttonSkip: {
    color: '#667185',
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontWeight: '600',
  },
};

export const tutorialSteps = [
  {
    target: '#step-1',
    title: 'Step 1',
    content: `Enter a description of the image you want to generate. It is best to stay below 380 characters. Example:
      [image content/subject, description of action, state, and mood], [art form, style, and artist references], [additional settings, such as lighting, colors, and framing] `,
    disableBeacon: true,
    disableOverlayClose: true,
    showSkipButton: true,
    locale: {
      close: 'Next',
      skip: 'Skip Tutorial',
    },
    styles: styles,
  },
  {
    target: '#step-2',
    title: 'Step 2',
    content: `Choose between a custom text prompt or select a pre-made template.`,
    disableBeacon: true,
    disableOverlayClose: true,
    showSkipButton: true,
    locale: {
      close: 'Next',
      skip: 'Skip Tutorial',
    },
    styles: styles,
  },
  {
    target: '#step-3',
    title: 'Step 3',
    content: `Select a filter to apply to your prompt.`,
    disableBeacon: true,
    disableOverlayClose: true,
    showSkipButton: true,
    locale: {
      close: 'Next',
      skip: 'Skip Tutorial',
    },
    styles: styles,
  },

  {
    target: '#step-4',
    title: 'Step 4',
    content: `Write a description or list anything you do not want to appear in your image.`,
    disableBeacon: true,
    disableOverlayClose: true,
    showSkipButton: true,
    locale: {
      close: 'Next',
      skip: 'Skip Tutorial',
    },
    styles: styles,
  },
  {
    target: '#step-5',
    title: 'Step 5',
    content: `Select your preferred image size or enter custom dimensions.`,
    disableBeacon: true,
    disableOverlayClose: true,
    showSkipButton: true,
    locale: {
      close: 'Next',
      skip: 'Skip Tutorial',
    },
    styles: styles,
  },
  {
    target: '#step-6',
    title: 'Step 6',
    content: `Select the number of unique images you want to generate.`,
    disableBeacon: true,
    disableOverlayClose: true,
    showSkipButton: true,
    locale: {
      close: 'Next',
      skip: 'Skip Tutorial',
    },
    styles: styles,
  },
  {
    target: '#search',
    title: 'Step 7',
    content: `Make any final edits to your prompt and generate your image.`,
    disableBeacon: true,
    disableOverlayClose: true,
    locale: {
      close: 'End Tutorial',
    },
    styles: styles,
  },
];
